import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollectionLayer } from '@adornis/baseql/server/collections.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { assertCanManageUsers } from '../server/access.js';
import { sendPasswordMail } from '../server/sendPasswordMail.js';

/**
 * Mail an existing account a fresh password link. The current password stays valid until
 * the link is actually used.
 *
 * @returns the address the mail went to
 */
export const sendPasswordResetMail = registerMutation({
  type: () => String,
  operationName: 'sendPasswordResetMail',
  resolve: (userID: string) => {
    return async () => {
      await assertCanManageUsers();

      const users = await getCollectionLayer<AdornisUser>(AdornisUser._collectionName);
      const user = await users.findOne({ _id: userID }, { projection: { email: 1 } });
      if (!user?.email) throw new ExpectedError('Für dieses Konto ist keine E-Mail-Adresse hinterlegt.');

      await sendPasswordMail(userID, user.email, { isInvitation: false });
      return user.email;
    };
  },
  params: [{ name: 'userID', type: () => String }],
});
